import { render, staticRenderFns } from "./SerchAttractionCategories.vue?vue&type=template&id=124ca23c&scoped=true"
import script from "./SerchAttractionCategories.vue?vue&type=script&lang=js"
export * from "./SerchAttractionCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124ca23c",
  null
  
)

export default component.exports